let url = 'http://localhost:8080';

if (process.env.REACT_APP_ENV == 'production') {
  url = 'https://api-expert.programadeexcelencia.com';
} else if (process.env.REACT_APP_ENV == 'development') {
  url = 'https://api-expert-dev.programadeexcelencia.com';
}

export default url;
